/**
 * Thin app-specific adapter around the shared agentChat composable.
 *
 * Core logic lives in `shared/ui/src/agent/agentChat.js` (via `@rm-ui`) so
 * both portals share one implementation. We pass the raw axios instance
 * here because rm-portal configures baseURL + auth on the global default
 * (unlike rm-portal-beta which uses a named instance).
 *
 * For socket streaming we adapt the Vue-2 event-bus singleton
 * (`plugins/events.js`) to the { on, off } shape the shared composable
 * expects. It returns a no-op if the gateway hasn't been connected yet —
 * streaming is best-effort, the REST response still carries the final text.
 */
import axios from 'axios';
import { agentChat as sharedAgentChat } from '@rm-ui/agent/agentChat';
import { getInstance } from '@/plugins/events.js';

function eventsAdapter() {
    return {
        on(event, handler) {
            const gw = getInstance();
            if (gw) gw.$on(event, handler);
        },
        off(event, handler) {
            const gw = getInstance();
            if (gw) gw.$off(event, handler);
        },
    };
}

export function agentChat() {
    return sharedAgentChat({ http: axios, events: eventsAdapter() });
}
